/*
* @Author: gujianghua
* @Date:   2020-08-03 10:02:42
* @Last Modified by:   gujianghua
* @Last Modified time: 2020-08-05 17:17:19
*/
import { service,BASE_API } from '@/utils/request'
import { searchParamsFormatter } from '@/api/common'

const v2 = BASE_API

export default {
	getList (params) {
		return service({
			url: '/cloud/statistic/events/admin/group/list',
			method: 'get',
			params: params
		})
	},
	save (data) {
		return service({
			url: '/cloud/statistic/events/group/save',
			method: 'post',
			data: data
		})    
	},
	userDetail (params) {
		return service({
			url: '/cloud/statistic/events/admin/group/user/list',
			method: 'get',
			params: params
		}) 
	},	
	userDetailCharts (params) {			 
		return service({
			url: '/cloud/statistic/events/admin/group/user/summary',
			method: 'get',
			params: params
		}) 
	},
	listByParameter(params) {
		return service({
			url: '/cloud/statistic/events/admin/group/user/listByParameter',
			method: 'get',
			params: params
		}) 
	},
	exportDetail(data) {
	    let url = v2 + '/cloud/statistic/events/admin/group/download/excel?' +
	      searchParamsFormatter(data)
	    window.location.href = url
	},
	exportDetail2(params) {		
		return service({
			url: '/cloud/statistic/events/admin/group/download/excelNew',
			method: 'get',
			params,
			responseType: 'blob'
		})
	},
	// exportDetail2(data) {
	//     let url = v2 + '/cloud/statistic/events/admin/group/download/excelNew?' +
	//       searchParamsFormatter(data)
	//     window.location.href = url
	// },
	deleteData (params) {
		return service({
			url: '/cloud/statistic/events/group/del',
			method: 'post',
			params: params
		}) 
	},
	// 事件参数列表
	paramsList(params) {
		return service({
			url: '/cloud/statistic/events/admin/events/infoList',
			method: 'get',
			params: params
		}) 
	},
	// 事件参数汇总
	paramsTotal(params) {
		return service({
			url: '/cloud/statistic/events/admin/events/infoTotal',
			method: 'get',
			params: params
		}) 
	},
	// 筛选条件
	fetchEventSelectInfo(params) {
		return service({
			url: '/cloud/statistic/events/admin/events/fetchEventSelectInfo',
			method: 'get',
			params
		}) 
	}
}


// WEBPACK FOOTER //
// ./src/api/databaseAnlysis/eventrecord.js